import { CollectionApiService } from '@aipb/personal-content/data-access';
import { Collection } from '@aipb/personal-content/shared/model';
import { PersonalContentRouting } from '@aipb/personal-content/shared/routing';
import { getCollectionLabel } from '@aipb/personal-content/shared/util';
import { SnackbarService } from '@aipb/ui/snackbar';

import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { TranslocoService } from '@jsverse/transloco';
import { tap } from 'rxjs';

@Component({
  selector: 'pc-join-collection-page',
  imports: [MatButtonModule, MatCardModule, MatListModule],
  templateUrl: './join-collection-page.component.html',
  styleUrls: ['./join-collection-page.component.scss']
})
export class JoinCollectionPageComponent implements OnInit {
  // @ts-expect-error foo
  @Input() uniqueId: string;
  // @ts-expect-error foo
  @Input() entryCode: string;
  // @ts-expect-error foo
  collection = signal<Collection>(null);
  private collectionApi = inject(CollectionApiService);
  private personalContentRouting = inject(PersonalContentRouting);
  private snackbar = inject(SnackbarService);
  private transloco = inject(TranslocoService);

  ngOnInit() {
    this.collectionApi
      .collectionCoopJoin({
        id: this.uniqueId,
        coopEntryCode: this.entryCode
      })
      .pipe(
        tap({
          next: (data) => {
            this.collection.set(data.collection);
            this.snackbar.open(
              this.transloco.translate('personal_content.coop.collection_join_successful', {
                value: getCollectionLabel(data.collection)
              }),
              'success'
            );
            //this.personalContentRouting.collectionSingle(data.collection.id);
          },
          error: () => {
            this.personalContentRouting.coopDefault();
          }
        })
      )
      .subscribe();
  }

  onRouteToCollection(collection: Collection) {
    this.personalContentRouting.collectionSingle(collection.id);
  }

  getLabel(collection: Collection) {
    return getCollectionLabel(collection);
  }
}
